<template lang="pug">
#ChatroomFooter.inputArea.border-top
  .py-3.px-2
    .row.no-gutters
      .col-9.pr-1.d-flex.align-items-center.justify-content-center
        textarea-autosize.border-0.rounded-20.shadow-none.w-100.px-3.py-2(
          v-model="text",
          placeholder="輸入訊息",
          rows="1",
          max-rows="6",
          ref="messageComposer",
          style="max-height: 200px;background-color: #eee;"
        )
      .col-3.d-flex.align-items-center.justify-content-center.pl-1.d-flex.align-items-center.justify-content-around
        .border.border-black.rounded-circle.p-1.d-flex.align-items-center.justify-content-center.mr-1(
          style="width: 40px;height: 40px;outline:none",
          @click="sendMsgHandler()"
        )
          a(
            href="javascript: void(0);"
          )
            b-img.rounded-circle(
              :src="iconUrl.IconSend",
              fluid,
              alt="Arrow Right"
            )
        .border.border-black.rounded-circle.p-1.d-flex.align-items-center.justify-content-center.ml-1.toolCollapse(
          style="width: 40px;height: 40px;outline:none",
          v-b-toggle.toolCollapse
        )
          a(
            href="javascript: void(0);"
          )
            b-img.rounded-circle(
              :src="iconUrl.IconShowTool",
              fluid,
              alt="Show More Tool"
            )
  b-collapse#toolCollapse(
    v-model="toolCollapseShow"
  )
    b-card.border-0.text-white.rounded-0(
      bg-variant="black"
    )
      .row.text-center#menu-wrapper
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconImg(
            onclick="imgUpload.click()"
          )
          small.w-100.mb-0.text-nowrap 相片
          input.d-none(
            type="file",
            accept="image/*",
            id="imgUpload",
            @change="imgFileUploadHandler",
            ref="imgUploadInput"
            multiple
          )
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconVideo(
            onclick="videoUpload.click()"
          )
          small.w-100.mb-0.text-nowrap 影片
          input.d-none(
            type="file",
            accept="video/*",
            id="videoUpload",
            @change="videoFileUploadHandler",
            ref="videoUploadInput"
          )
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconSticker(
            @click="openModelHandler('sticker')"
          )
          small.w-100.mb-0.text-nowrap 貼圖
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconTemp(
            @click="openModelHandler('temp')"
          )
          small.w-100.mb-0.text-nowrap 訊息模板
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconReserve(
            @click="openModelHandler('reservation')"
          )
          small.w-100.mb-0.text-nowrap 顧客預約
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconInvite(
            @click="openModelHandler('invitation')"
          )
          small.w-100.mb-0.text-nowrap 邀請函
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconLinePoint(
            @click="openModelHandler('linePoint')"
          )
          small.w-100.mb-0.text-nowrap LINE Point
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconTag(
            @click="openModelHandler('tag')"
          )
          small.w-100.mb-0.text-nowrap 顧客喜好
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconMyCustomer(
            @click="openModelHandler('myCustomer')"
          )
          small.w-100.mb-0.text-nowrap 我的顧客
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconProductFit(
            @click="openModelHandler('productBuy')"
          )
          small.w-100.mb-0.text-nowrap 熟客導購
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconProductFit(
            @click="openModelHandler('productFit')"
          )
          small.w-100.mb-0.text-nowrap 產品連結
        .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
          i.iconOrderOnline(
            @click="openModelHandler('orderOnline')"
          )
          small.w-100.mb-0.text-nowrap 預選清單

</template>

<script>
import IconSendUrl from '@/assets/images/icon/icon_arrow_right.png';
import IconShowToolUrl from '@/assets/images/icon/icon_plus.png';
import IconInviteUrl from '@/assets/images/icon/icon_invite.png';
import $ from 'jquery';

export default {
    name: 'ChatroomFooter',
    props: {
      user: {
        type: Object,
        default: null
      }
    },
    data() {
        return {
            iconUrl: {
              IconSend: IconSendUrl,
              IconShowTool: IconShowToolUrl,
              IconInvite: IconInviteUrl
            },
            toolCollapseShow: false,
            text: null
        };
    },
    methods: {
      sendMsgHandler() {
        const vm = this;
        if (!vm.text || vm.text === '') return;
        vm.$emit('sendHandler', {
          type: 'text',
          text: vm.text
        });
        vm.text = '';
        this.toolCollapseShow = false;
      },
      imgFileUploadHandler() {
        const vm = this;
        let obj = vm.$refs.imgUploadInput;
        if (!obj || !obj.files[0]) return;
        if (obj.files.length > 5) {
          vm.$swal.fire({
            icon: 'error',
            title: '錯誤',
            text: '相片最多只能上傳 5 張',
            allowOutsideClick: false,
            heightAuto: false,
          }).then(() => {
            obj.value = null;
          });
          return;
        }

        const files = Array.from(obj.files);
        const readPromises = files.map(file => {
          return new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {
              const src = e.target.result;
              resolve({
                type: 'image',
                file,
                src
              });
            };
          });
        });

        Promise.all(readPromises).then(sendData => {
          const formData = new FormData();
          sendData.forEach((data, index) => {
            formData.append(`image${index + 1}`, data.file);
          });

          vm.$emit('sendHandler', {
            type: 'image',
            formData
          });

          obj.value = null;
          vm.toolCollapseHandler();
        });
      },
      videoFileUploadHandler() {
        const vm = this;
        let obj = vm.$refs.videoUploadInput;
        if (!obj || !obj.files[0]) return;

        const file = obj.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          // 取得路徑
          const src = e.target.result;

          // 傳送事件到父元件
          const form = new FormData();
          form.append('video', file);
          const data = {
            file: form
          };

          vm.$emit('sendHandler', {
            type: 'video',
            file: data,
            src
          });
          obj.value = null;
          vm.toolCollapseHandler();
        };
      },
      // 關閉工具彈窗
      toolCollapseHandler() {
        this.toolCollapseShow = !this.toolCollapseShow;
      },
      openModelHandler(type) {
        const vm = this;
        $('.icon-back').addClass('d-none');
        switch (type) {
          case 'sticker':
            vm.$EventBus.$emit('openStickerModel');
            break;
          case 'temp':
            vm.$EventBus.$emit('openTempModel');
            break;
          case 'reservation':
            vm.$swal.fire({
              title: '載入中，請稍候',
              allowOutsideClick: false,
              heightAuto: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });
            // // 取得預約時間列表
            // vm.$store.dispatch('sa_reservation/getReservationTimeListHandler')
            //   .then(() => {

            //   });
            // 取得預約服務選項
            vm.$store.dispatch('sa_reservation/getReservationTypeListHandler')
              .then(() => {
                vm.$swal.close();
                vm.$EventBus.$emit('openReservationModel');
              });
            break;
          case 'tag':
            vm.$swal.fire({
              title: '載入中，請稍候',
              allowOutsideClick: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });

            // 取得所有標籤
            vm.$store.dispatch('sa_reservation/getTagsHandler')
              .then(() => {
                // 取得該使用者的標籤
                vm.$store.dispatch('sa_reservation/getMemberTagsHandler', `${vm.user.member_uuid || vm.user.member_line_uuid}`)
                  .then(() => {
                    vm.$swal.close();
                    vm.$EventBus.$emit('openTagModel', vm.user);
                  });
              });
            break;
          case 'invitation':
            vm.$EventBus.$emit('openInvitationModel');
            break;
          case 'myCustomer':
            vm.$EventBus.$emit('openMyCustomerModel');
            break;
          case 'orderOnline':
            vm.$EventBus.$emit('openOrderOnlineModel');
            break;
          case 'productBuy':
            vm.$EventBus.$emit('openProductBuyModel');
            break;
          case 'productFit':
            vm.$EventBus.$emit('openProductFitModel');
            break;
          case 'linePoint':
            vm.$EventBus.$emit('openLinePointModel');
            break;
          default:
            break;
        }
         vm.toolCollapseHandler();
      }
    }
};
</script>

<style lang="scss" scoped>

@font-face {
  font-family: "icon";
  src: url("../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.8rem;
  margin-bottom: 4px;
}

.iconImg:before {
  content: "\e902";
}

.iconVideo:before {
  content: "\e905";
}

.iconSticker:before {
  content: "\e91a";
}

.iconTemp:before {
  content: "\e90c";
}

.iconReserve:before {
  content: "\e916";
}

.iconTag:before {
  content: "\e90b";
}

.iconInvite:before {
  content: "\e918";
}

.iconProductFit:before {
  content: "\e91c";
}

.iconMyCustomer:before {
  content: "\e915";
}

.iconOrderOnline {
    position: relative;
    display: inline-block;
    width: 75%;
    height: 30px;
}
.iconOrderOnline:before {
    content: '';
    width: 45px;
    height: 30px;
    /* padding-bottom: 70%; */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    position: absolute;
    background: url(../../assets/fonts/font-icon/chat_bottomMenu_order.svg) no-repeat center center;
    background-size: 100%;
}
.iconLinePoint {
    position: relative;
    display: inline-block;
    width: 75%;
    height: 30px;
}
.iconLinePoint:before {
    content: '';
    width: 45px;
    height: 30px;
    /* padding-bottom: 70%; */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    position: absolute;
    background: url(../../assets/images/icon/icon_point.png) no-repeat center center;
    background-size: 65%;
}

.toolCollapse {
  img {
    transition: all .3s;
    transform: rotate(0deg);
  }
}

.collapsed {
  transition: all .3s;
  transform: rotate(0deg);
}

.not-collapsed {
  img {
    transform: rotate(225deg);
  }
}

// 底下選單改為左右滑動式
#toolCollapse {
  max-height: 150px;
  overflow-x: auto;
  overflow-y: hidden;
}
#toolCollapse > div {
  width: 150%;
}
#menu-wrapper > div {
  flex: 0 0 calc(100% / 6);
  max-width: calc(100% / 6);
}
</style>
